import React from "react";
import { useForm } from "react-hook-form";
import { Form, FormFields, FormTextField, FormNumberTextField, FormActions } from "sprint-common-web";

import { EpisodeDetails } from "../../../../TvSeriesDetails";
import { CreateEpisodeFormInputs } from "./CreateEpisodeFormInputs";
import { useCreateEpisodeForm } from "./useCreateEpisodeForm";

export interface CreateEpisodeFormProps {
    onCancel(): void;
    onSubmit(episode: EpisodeDetails): void;
}

export const CreateEpisodeForm: React.FunctionComponent<CreateEpisodeFormProps> = (props: CreateEpisodeFormProps) => {
    const { errors, control, formState, reset, handleSubmit } = useForm<CreateEpisodeFormInputs>({
        defaultValues: {
            title: ""
        },
        criteriaMode: "all"
    });

    const { createNewEpisode, isNewEpisodeTitleUnique, isNewEpisodeNumberUnique } = useCreateEpisodeForm();

    const handleAddNewEpisode = async (inputs: CreateEpisodeFormInputs) => {
        const episode = await createNewEpisode(inputs);
        props.onSubmit(episode);
        reset();
    };

    const handleCancelClick = () => {
        props.onCancel();
    };

    return (
        <Form onSubmit={handleSubmit(handleAddNewEpisode)}>
            <FormFields>
                <FormTextField
                    label="Title"
                    name="title"
                    control={control}
                    errors={errors}
                    rules={{ required: "Enter episode title", validate: isNewEpisodeTitleUnique }}
                />
                <FormNumberTextField
                    label="Episode number"
                    name="number"
                    control={control}
                    errors={errors}
                    rules={{
                        required: "Enter episode number",
                        pattern: {
                            value: /^\d+$/i,
                            message: "Enter correct episode number"
                        },
                        validate: isNewEpisodeNumberUnique
                    }}
                />
            </FormFields>
            <FormActions isLoading={formState.isSubmitting || formState.isValidating} onCancel={handleCancelClick} />
        </Form>
    );
};
